(function() {
  'use strict';

  class BlogLoadMore {
    constructor(container) {
      this.selectors = {
        blogContainer: '[data-blog-container]',
        loadMoreBtn: '[data-load-more-blog]',
        pagination: '.sf__blog-paginate',
        itemsTo: '[data-items-to]'
      };

      this.container = container;
      this.currentPage = 1;
      this.totalPages = 1;
      this.isLoading = false;

      this.init();
    }

    init() {
      if (!this.container) return;

      const blogContainer = this.container.querySelector(this.selectors.blogContainer);
      const loadMoreBtn = this.container.querySelector(this.selectors.loadMoreBtn);

      if (!blogContainer || !loadMoreBtn) return;

      // Prevent double initialization
      if (this.container.dataset.loadMoreInitialized) return;
      this.container.dataset.loadMoreInitialized = 'true';

      this.blogContainer = blogContainer;
      this.loadMoreBtn = loadMoreBtn;
      this.pagination = this.container.querySelector(this.selectors.pagination);
      this.totalPages = parseInt(blogContainer.dataset.totalPages) || 1;

      this.bindEvents();
    }

    bindEvents() {
      if (this.loadMoreBtn) {
        this.loadMoreBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleLoadMore();
        });
      }
    }

    handleLoadMore() {
      if (this.isLoading || this.currentPage >= this.totalPages) return;

      this.toggleLoading(true);
      this.currentPage++;

      // Build URL properly handling hash fragments and existing params
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('page', this.currentPage);
      // Remove hash for the fetch request (not needed for AJAX)
      urlObj.hash = '';
      const url = urlObj.toString();

      fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        this.toggleLoading(false);

        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newArticles = doc.querySelector(this.selectors.blogContainer);

        if (newArticles) {
          // Append new articles to the existing container
          Array.from(newArticles.children).forEach(article => {
            this.blogContainer.appendChild(article.cloneNode(true));
          });

          // Update items counter by counting actual visible items
          this.updateItemsCounter();
        }

        // Hide button if no more pages
        if (this.currentPage >= this.totalPages) {
          if (this.pagination) {
            this.pagination.classList.add('hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error loading more articles:', error);
        this.toggleLoading(false);
      });
    }

    toggleLoading(status) {
      this.isLoading = status;

      if (!this.loadMoreBtn) return;

      if (status) {
        this.loadMoreBtn.classList.add('sf-spinner-loading');
      } else {
        setTimeout(() => {
          this.loadMoreBtn.classList.remove('sf-spinner-loading');
        }, 150);
      }
    }

    updateItemsCounter() {
      // Re-query elements fresh from DOM to avoid stale references
      if (!this.container) return;

      const itemsToEl = this.container.querySelector(this.selectors.itemsTo);
      const blogContainer = this.container.querySelector(this.selectors.blogContainer);

      if (itemsToEl && blogContainer) {
        // Count actual article cards in the container
        const articleCards = blogContainer.querySelectorAll('.sf__blog-card');
        itemsToEl.textContent = articleCards.length;
      }
    }
  }

  // Find and initialize all blog sections with load more
  function initAllBlogSections() {
    const blogSections = document.querySelectorAll('[data-section-type="blog-template"][data-paginate-type="loadmore"], [data-section-type="blog-posts"][data-paginate-type="loadmore"]');
    blogSections.forEach(section => new BlogLoadMore(section));
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBlogSections);
  } else {
    initAllBlogSections();
  }

  // Also reinitialize on Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    const blogSection = event.target.querySelector('[data-section-type="blog-template"], [data-section-type="blog-posts"]');
    if (blogSection && blogSection.dataset.paginateType === 'loadmore') {
      // Remove initialized flag to allow re-initialization
      blogSection.removeAttribute('data-load-more-initialized');
      new BlogLoadMore(blogSection);
    }
  });
})();
